/**
 * YouTube-Tags im Cockpit (CUR-2295) — Zählung und Eingabe. Eigene Datei, weil `bausteine.tsx`
 * Komponenten exportiert und Hilfsfunktionen dort das Fast Refresh brechen.
 */
/** Obergrenze der YouTube-Tags einer Fassung — dieselbe wie im Backend (`YOUTUBE_TAGS_MAX`, CUR-2295). */
export const YOUTUBE_TAGS_MAX = 500;

/**
 * Wie YouTube Tags zählt: Kommas dazwischen zählen mit, ein Tag mit Leerzeichen
 * mit Anführungszeichen. Gespiegelt aus `youtubeTagZeichen()` im Backend
 * (social.schema.ts) — der Server prüft, hier steht nur die Anzeige.
 */
export function youtubeTagZeichen(tags: readonly string[]): number {
  return tags.reduce((n, t) => n + t.length + (/\s/.test(t) ? 2 : 0), 0) + Math.max(0, tags.length - 1);
}

/**
 * `Diabetes, Insulin,  Typ 2 ` → `['Diabetes', 'Insulin', 'Typ 2']` — leere und doppelte fallen weg.
 * Zeilenumbrüche trennen wie Kommas: Eine eingefügte Liste „ein Tag je Zeile" soll nicht als ein Tag landen.
 */
export function youtubeTagsAusText(text: string): string[] {
  return [...new Set(text.split(/[,\n\r]/).map((t) => t.trim()).filter(Boolean))];
}
